import URLS from '../../config/urls'
import ajax from './ajax'
const huiduHosts = ['monitor_huidu.ushow.media', 'monitor-huidu.ushow.media']
let base = (typeof window !== 'undefined' && huiduHosts.indexOf(window.location.hostname) > -1)
  ? URLS.HUIDU_API_URL
  : URLS.API_URL
let slowBase = URLS.SLOW_API_URI;
let cicdBase = URLS.SLOW_API_URI;

// 会议室相关
export const getMeetingList = params => { return ajax.get(`${base}/meeting/v1/list/` + params).then(res => res) }
export const getMeetingDetail = params => { return ajax.get(`${base}/meeting/v1/detail/` + params).then(res => res) }
export const requestCreateMeeting = params => { return ajax.post(`${base}/meeting/v1/list/`, params).then(res => res) }
export const requestMeetingOrderCancel = params => { return ajax.post(`${base}/meeting/v1/cancellation/`, params).then(res => res) }
export const getMeetingOrderInfo = params => { return ajax.get(`${base}/meeting/v1/orderinfo/` + params).then(res => res) }
export const requestMeetingOrderInfoUpdate = params => { return ajax.post(`${base}/meeting/v1/update/`, params).then(res => res) }


// 监控相关

// 监控灰度自定义部分
export const getCounter = params => { return ajax.get(`${base}/monitor/v1/list/customConfig/` + params).then(res => res) }
export const getPrometheusMonitorList = params => { return ajax.get(`${base}/monitor/v1/list/prometheusConfig/` + params).then(res => res) }
export const handlePrometheusMonitorList = params => { return ajax.post(`${base}/monitor/v1/list/prometheusConfig/`, params).then(res => res) }
export const getCustomMonitorList = params => { return ajax.get(`${base}/monitor/v1/list/customConfig/` + params).then(res => res) }
export const handleCustomMonitorList = params => { return ajax.post(`${base}/monitor/v1/list/customConfig/`, params).then(res => res) }
export const getEndpointAlarmCounter = params => { return ajax.get(`${base}/monitor/v1/list/customConfig/` + params).then(res => res) }
export const changeAlarmMethod = params => { return ajax.post(`${base}/monitor/v1/list/customConfig/`, params).then(res => res) }

export const getMonitorList = params => { return ajax.get(`${base}/monitor/v1/list/alarmConfig/` + params).then(res => res) }  // TODO 获取所有的监控配置项
export const handleMonitorList = params => { return ajax.post(`${base}/monitor/v1/list/alarmConfig/`, params).then(res => res) } //编辑报警配置
export  const getGroupList = params => { return ajax.get(`${base}/monitor/v1/list/groupConfig/` + params).then(res => res) }
export const handleGroupList = params => { return ajax.post(`${base}/monitor/v1/list/groupConfig/`, params).then(res => res) } //编辑报警配置
export const getSpecialConfig = params => { return ajax.get(`${base}/monitor/v1/list/sepcialConfig/` + params).then(res => res) } //获取特殊策略配置
export const handleSpecialConfig = params => { return ajax.post(`${base}/monitor/v1/list/sepcialConfig/` , params).then(res => res) } //编辑特殊策略配置

export const getMaintianConfigList = params => {return ajax.get(`${base}/monitor/v1/list/maintianConfig/` + params).then(res => res)} //获取maintian配置
export const handMaintianConfigList = params => {return ajax.post(`${base}/monitor/v1/list/maintianConfig/`,params).then(res => res)} //编辑maintian配置
//监控-event相关
export const getMonitorEvenntList = params => { return ajax.get(`${base}/monitor/v1/list/eventConfig/` + params).then(res => res) } //获取报警配置
// 获取region cvm config配置

export const getCvmConfigList = params => {
  return ajax.get(`${base}/workorder/v1/cvm/config/` + params).then(res => res)
}

// // 用户相关
export const requestLogin = params => { return ajax.post(`${base}/users/v1/user/login/`, params).then(res => res) }
//登出
export const requestLogout = params => { return ajax.get(`${base}/users/v1/user/logout/` + params).then(res => res) }
//获取登录信息
export const userPasswdModifyNew = params => { return ajax.post(`${base}/users/v1/user/userPasswdModifyNew/`,params).then(res => res)}

export  const checkPasswdToken  = params => { return ajax.get(`${base}/users/v1/user/passwdTokenCheck/` + params).then(res => res) }

export const fishLogin = params => { return ajax.post(`${base}/users/v1/user/fishlogin/` ,params).then(res => res) }
export const feishuLoginCallback = params => { return ajax.post(`${base}/users/v1/user/feishu/login/callback/`, params).then(res => res) }
//获取所有的用户
export const getAllUserInfo = params => { return ajax.get(`${base}/users/v1/user/getAllUser/`, params).then(res => res)}
//添加代理人
export const requestAddAgentUser = params => { return ajax.post(`${base}/users/v1/add_agent/`, params).then(res => res) }
//用户密码修改
export const userPasswdModify = params => { return ajax.post(`${base}/users/v1/user/userPasswdModify/`,params).then(res => res)}
//获取用户信息
export const getUserInfoRequest = params => { return ajax.get(`${base}/users/v1/user/userInfo/` + params).then(res => res) }
// 获取工单模板
export const getOrderTemplateRequest = params => { return ajax.get(`${base}/workorder/ordertpl/list/` + params).then(res => res) } // uuid

//工单参数检查
export const createOrderPreCheckRequest = params => { return ajax.post(`${base}/workorder/workorder/check/`,params).then(res => res) } // uuid
// 获取指定模板字段配置
// export const getOrderFieldConfRequest = params => { return ajax.get(`${base}/api_workflow/ordertpl/conf/` + params).then(res => res) } // uuid
export const getOrderFieldConfRequest = params => { return ajax.get(`${base}/workorder/ordertpl/conf/` + params).then(res => res) } // uuid

// 获取指定模板审批流程和工单配置信息
// export const getOrderFlowStepRequest = params => { return ajax.get(`${base}/api_workflow/ordertpl/flow_step/` + params).then(res => res) } // uuid
export const getOrderFlowStepRequest = params => { return ajax.get(`${base}/workorder/ordertpl/flow_step/` + params).then(res => res) } // uuid

// 创建工单
// export const requestOrderCreate = params => { return ajax.post(`${base}/api_workflow/workorder/create/`, params).then(res => res) }
export const requestOrderCreate = params => { return ajax.post(`${base}/workorder/workorder/create/`, params).then(res => res) }

// 获取申请的工列表
// export const getSubmitOrderRequest = params => { return ajax.get(`${base}/api_workflow/workorder/list/` + params).then(res => res) } // uuid
export const getSubmitOrderRequest = params => { return ajax.get(`${base}/workorder/workorder/list/` + params).then(res => res) } // uuid

//获取suborder自动工单执行日志
export const getSubOrderLogRequest = params => { return ajax.get(`${base}/workorder/suborder/callbackLog/` + params).then(res => res) }
// 获取待我审批工单
// export const getApproveSubOrderRequest = params => { return ajax.get(`${base}/api_workflow/suborder/list/` + params).then(res => res) } // uuid
export const getApproveSubOrderRequest = params => { return ajax.get(`${base}/workorder/suborder/list/` + params).then(res => res) } // uuid

// 获取SubOrder中用户提交工单描述信息
export const getSubOrderDescRequest = params => { return ajax.get(`${base}/workorder/suborder/desc/` + params).then(res => res) } // uuid

// 获取SubOrder审批步骤
export const getSubOrderStepRequest = params => { return ajax.get(`${base}/workorder/suborder/step/` + params).then(res => res) } // uuid

// 审批工单
export const requestSuborderApprove = params => { return ajax.post(`${base}/workorder/suborder/approve/`, params).then(res => res) }



// 重置工单状态
export const requestSuborderStatusReset = params => { return ajax.post(`${base}/workorder/suborder/reset/`, params).then(res => res) }


// 用户撤回自己的工单
export const requestWorkorderWithdraw = params => { return ajax.post(`${base}/api_workflow/workorder/withdraw`, params).then(res => res) }



// 自动化工单重试/跳过
export const requestRetrySuborderApprove = params => { return ajax.post(`${base}/api_workflow/suborder/retry_approve/`, params).then(res => res) }

// 北森相关

export const requestItalenRequest = params => { return ajax.get(`${base}/italen/v1/attendance/` + params).then(res => res) } // uuid


// 修改工单
export const requestWorkOrderModify = params => { return ajax.post(`${base}/api_workflow/workorder/modify/`, params).then(res => res) }

// 催单
export const requestRemindSuborderApprove = params => { return ajax.post(`${base}/api_workflow/suborder/remind/`, params).then(res => res) }

// 获取用户信息
// export const getUserInfoRequest = params => { return ajax.get(`${base}/api_workflow/userinfo/` + params).then(res => res) } // uuid

// 添加代理人
// export const requestAddAgentUser = params => { return ajax.post(`${base}/api_workflow/add_agent/`, params).then(res => res) }

// 获取工单所有工单模板
export const getFlowConfRequest = params => { return ajax.get(`${base}/api_workordermanager/flowconf/` + params).then(res => res) } // uuid


// 实时获取lb后端的target
export const getClbBackendTarget = params => {return ajax.get(`${base}/workorder/clb/target/` + params).then(res => res)}
// 修改工单显示状态
export const operateFlowconfShowRequest = params => { return ajax.get(`${base}/api_workordermanager/flowconf/manage/` + params).then(res => res) } // uuid

// 新建工单
export const operateCreateFlowconfRequest = params => { return ajax.post(`${base}/api_workordermanager/flowconf/manage/`, params).then(res => res) }

// 获取mis部门树
export const getMisDeptTreeRequest = params => { return ajax.get(`${base}/api_workordermanager/mis/depttree/` + params).then(res => res) } // uuid

// 获取mis对应部门人员
export const getMisDeptPersonsRequest = params => { return ajax.get(`${base}/api_workordermanager/flowconf/deptperson/` + params).then(res => res) } // uuid

// 获取人员pool名
export const getPersonPoolsRequest = params => { return ajax.get(`${base}/api_workordermanager/person/pools/` + params).then(res => res) } // uuid

// 获取FlowConf工单模板审批流
export const getFlowRoleConfRequest = params => { return ajax.get(`${base}/api_workordermanager/flowroleconf/` + params).then(res => res) } // uuid

// del NewFlowUserRoleActionConf
// export const requestFlowRoleConf = params => { return ajax.post(`${base}/api_workordermanager/flowroleconf/` + params).then(res => res) } // uuid
export const requestFlowRoleConf = params => { return ajax.post(`${base}/api_workordermanager/flowroleconf/`, params).then(res => res) }

// 选中工单模板分类列表
export const getFlowConfClassingRequest = params => { return ajax.get(`${base}/api_workordermanager/flowconf/classing/` + params).then(res => res) } // uuid

// 提交工单分类
export const requestFlowConfClassing = params => { return ajax.post(`${base}/api_workordermanager/flowconf/classing/`, params).then(res => res) }

// 获取自动化工原有配置
export const getAutoActionConfRequest = params => { return ajax.get(`${base}/api_workordermanager/flowconf/autoaction/` + params).then(res => res) } // uuid

// 提交修改后的自动化工单
export const requestModifyFlowRoleConf = params => { return ajax.post(`${base}/api_workordermanager/flowconf/autoaction/`, params).then(res => res) }

// 查询慢sql

export const getSlowQueryRequest = params => { return ajax.get(`${slowBase}/devops-goserver-v1/slowquery/search/` + params).then(res => res)};
export const getSlowQueryDbRequest = params => { return ajax.get(`${slowBase}/devops-goserver-v1/slowquery/getDb/` + params).then(res => res)};

// CICD配置
export const getCicdHistoryRequest = params => { return ajax.get(`${cicdBase}/cicd/history/` + params).then(res => res)}
export const getCicdHistoryLogRequest = params => { return ajax.get(`${cicdBase}/cicd/historyLog/` + params).then(res => res)}


// 快速报警配置

export const getFastAlarmConfig = params => { return ajax.get(`${slowBase}/devops-goserver-v1/monitor/url-rule/` + params).then(res => res)};
export const handleFastAlarmConfig = params => { return ajax.post(`${slowBase}/devops-goserver-v1/monitor/url-rule/` ,params).then(res => res)};

export const getMonitorReport = params => {return ajax.get(`${slowBase}/monitor/v1/api/monitorReport/` + params).then(res => res)}

// cdnconfig配置

export const getCdnConfigAll = params => { return ajax.get(`${slowBase}/devops-goserver-v1/cdnconfig/all/` + params).then(res => res)};
export const handleCdnConfigAll = params => { return ajax.post(`${slowBase}/devops-goserver-v1/cdnconfig/editConfig/` ,params).then(res => res)};
export const getCountryCodeAll = params => { return ajax.get(`${slowBase}/devops-goserver-v1/cdnconfig/countryCode/` + params).then(res => res)};
export const deleteCdnConfigAll = params => { return ajax.delete(`${slowBase}/devops-goserver-v1/cdnconfig/editConfig/` + params).then(res => res)};
export const getCdnApp = params => { return ajax.get(`${slowBase}/devops-goserver-v1/cdnconfig/appConfig/` + params).then(res => res)};

export const handleDevopsApi = params => {
  const user = "devopsapi";
  const token = "yd7EOacdAlhO5wb0Zl1wPxRQIKZXL7";
  params["user"] = user;
  params["token"] = token;
  return ajax.post(`${slowBase}/v2/api`,params).then(res => res)
};

export const handleWsCheck = params => {
  return ajax.post(`${slowBase}/api/ws/check`,params).then(res => res)
};

export const getJobConfigAPI = params => {
  // return ajax.get(`${base}/starmakerR/getjobconfig/?job_name=` + params)
  return Axios.get(`${base}/starmakerR/getjobconfig/?job_name=` + params).then(response => response)
}



// WEBPACK FOOTER //
// ./src/api/api.js